<template lang="pug">
.arrControl
  Modal(v-model='value',width='860',:closable='false',:transfer='false',:footer-hide='true',:mask-closable='false')
    div.Multiple(v-if='Pattern')
      component(v-for='(item,index) in content',v-if='comState',:key='index',:is='item.type',:cont='item',ref='comp'
        ,:HistoryData='HistoryData[index]',:Boer="Boer").com
      Button.bottom-button(@click='Sure',:loading="isWorking")  {{Pattern?'确定':'知道啦'}}
    div.Multiple(v-else)
      component(:is='cont.type',:cont='cont',:Boer="Boer")
      Button.bottom-button(@click='Sure1',:loading="isWorking")  {{Pattern?'确定':'知道啦'}}
  component(v-if='cont.type!=="PICTURETEXT"',:is='cont.type',:cont='cont',@next='$emit("Determine")')
</template>

<script>
/* eslint-disable indent */
import bus from "@/utils/main";
import SINGLECHOICE from "@/components/doCase/doControl/doSubject/SINGLECHOICE"; // 单选题
import MULTIPLECHOICEA from "@/components/doCase/doControl/doSubject/MULTIPLECHOICEA"; // 多选题1
import MULTIPLECHOICEB from "@/components/doCase/doControl/doSubject/MULTIPLECHOICEB"; // 多选题2
import GAPFILLING from "@/components/doCase/doControl/doSubject/GAPFILLING"; // 填空题
import ESSAYQUESTION from "@/components/doCase/doControl/doSubject/ESSAYQUESTION"; // 问答题
import FILLBLANKS from "@/components/doCase/doControl/doSubject/FILLBLANKS"; // 选择填空题
import SINGLETEXT from "@/components/doCase/doControl/doCaseContent/SINGLETEXT"; // 单文字控件
import TEXTAXIS from "@/components/doCase/doControl/doCaseContent/TEXTAXIS"; // 轴型文字
import PICTURETEXT from "@/components/doCase/doControl/doCaseContent/PICTURETEXT"; // 图文
import VIDEOFILE from "@/components/doCase/doControl/doCaseContent/VIDEOFILE"; // 视频
import DIALOGUE from "@/components/doCase/doControl/doCaseContent/DIALOGUE"; // 对话
import HEADLINE from "@/components/doCase/doControl/doCaseContent/HEADLINE"; // 标题
import SMALLTITLE from "@/components/doCase/doControl/doCaseContent/SMALLTITLE"; // 对话

export default {
  methods: {
    query() {
      this.comState = false;
      this.HistoryData = [];
      setTimeout(() => {
        console.log(sessionStorage.getItem("doIndex"));
        if (+sessionStorage.getItem("doIndex") === -1) {
          this.$emit("Determine");
          return;
        }
        const data = {
          caseHallId: this.$store.state.doCase.caseData[
            this.step[+sessionStorage.getItem("doIndex")]
          ].tsId,
          classId: sessionStorage.getItem("classId"),
          experimentId: this.$store.state.doCase.experimentId,
          pyId: this.$store.state.doCase.caseId,
          tsId: this.$parent.cont
            ? this.$parent.cont.id
            : this.$store.state.doCase.caseData[
                this.step[+sessionStorage.getItem("doIndex")]
              ].tsId,
          userId: this.$role.code
        };
        this.$http.listStuControl(data).then(res => {
          console.log("1");

          this.cont.forEach((element, index) => {
            const find = value => {
              return value.controlId === element.id;
            };
            // console.log(this.cont.find(find));
            console.log(res.data.data);
            if (res.data.data) {
              if (res.data.data.find(find)) {
                this.HistoryData[index] = res.data.data.find(find);
              }
            }
          });
          this.comState = true;
          bus.$emit("histchange");
          this.content = this.cont;
        });
        console.log(this.HistoryData);
        console.log(this.content);
        console.log(this);
      }, 100);
    },
    Sure1() {
      this.$emit("Determine");
    },
    Sure() {
      if (this.Completed) {
        return this.$emit("Determine");
      }
      let state = true;
      const data = [];
      this.$refs.comp.forEach(element => {
        if (element.item) {
          let data2 = {};
          const idid = this.$store.state.doCase.caseData[
            this.step[+sessionStorage.getItem("doIndex")]
          ].tsId;

          switch (element.cont.type) {
            case "SINGLECHOICE":
              if (element.item.option === "") {
                state = false;
                //
              }
              data2 = {
                caseHallId: this.$store.state.doCase.caseData[
                  this.step[+sessionStorage.getItem("doIndex")]
                ].tsId,
                caseStep: this.step[+sessionStorage.getItem("doIndex")],
                classId: sessionStorage.getItem("classId"),
                controlId: element.cont.id,
                id: element.id ? element.id : "",
                controlTypes: element.cont.type,
                experimentId: this.$store.state.doCase.experimentId,
                pyId: this.$store.state.doCase.caseId,
                questionAnswer: element.item.option,
                tsId: this.$parent.cont ? this.$parent.cont.id : idid,
                userId: this.$role.code
              };
              console.log(data2);
              break;
            case "MULTIPLECHOICEA":
              if (element.item.option.length === 0) {
                state = false;
              }
              data2 = {
                caseHallId: this.$store.state.doCase.caseData[
                  this.step[+sessionStorage.getItem("doIndex")]
                ].tsId,
                caseStep: this.step[+sessionStorage.getItem("doIndex")],
                classId: sessionStorage.getItem("classId"),
                controlId: element.cont.id,
                id: element.id ? element.id : "",
                controlTypes: element.cont.type,
                experimentId: this.$store.state.doCase.experimentId,
                pyId: this.$store.state.doCase.caseId,
                questionAnswer: JSON.stringify(element.item.option),
                tsId: this.$parent.cont ? this.$parent.cont.id : idid,
                userId: this.$role.code
              };
              break;
            case "MULTIPLECHOICEB":
              if (element.item.option.length === 0) {
                state = false;
              }
              data2 = {
                caseHallId: this.$store.state.doCase.caseData[
                  this.step[+sessionStorage.getItem("doIndex")]
                ].tsId,
                caseStep: this.step[+sessionStorage.getItem("doIndex")],
                classId: sessionStorage.getItem("classId"),
                controlId: element.cont.id,
                id: element.id ? element.id : "",
                controlTypes: element.cont.type,
                experimentId: this.$store.state.doCase.experimentId,
                pyId: this.$store.state.doCase.caseId,
                questionAnswer: JSON.stringify(element.item.option),
                tsId: this.$parent.cont ? this.$parent.cont.id : idid,
                userId: this.$role.code
              };
              break;
            case "GAPFILLING":
              if (element.item.type.length === 0) {
                state = false;
              }
              data2 = {
                caseHallId: this.$store.state.doCase.caseData[
                  this.step[+sessionStorage.getItem("doIndex")]
                ].tsId,
                caseStep: this.step[+sessionStorage.getItem("doIndex")],
                classId: sessionStorage.getItem("classId"),
                controlId: element.cont.id,
                id: element.id ? element.id : "",
                controlTypes: element.cont.type,
                experimentId: this.$store.state.doCase.experimentId,
                pyId: this.$store.state.doCase.caseId,
                questionAnswer: JSON.stringify(element.item.type),
                tsId: this.$parent.cont ? this.$parent.cont.id : idid,
                userId: this.$role.code
              };
              break;
            case "ESSAYQUESTION":
              if (element.item.option === "") {
                state = false;
              }
              data2 = {
                caseHallId: this.$store.state.doCase.caseData[
                  this.step[+sessionStorage.getItem("doIndex")]
                ].tsId,
                caseStep: this.step[+sessionStorage.getItem("doIndex")],
                classId: sessionStorage.getItem("classId"),
                id: element.id ? element.id : "",
                controlId: element.cont.id,
                controlTypes: element.cont.type,
                experimentId: this.$store.state.doCase.experimentId,
                pyId: this.$store.state.doCase.caseId,
                questionAnswer: element.item.option,
                tsId: this.$parent.cont ? this.$parent.cont.id : idid,
                userId: this.$role.code
              };
              break;
            case "FILLBLANKS":
              if (JSON.stringify(element.item.list).indexOf('"') === -1) {
                state = false;
              }
              element.item.list.forEach(e => {
                if (e.department === "" || e.content === "") {
                  this.$Message.warning("请填写完整");
                  state = false;
                }
              });
              data2 = {
                caseHallId: this.$store.state.doCase.caseData[
                  this.step[+sessionStorage.getItem("doIndex")]
                ].tsId,
                caseStep: this.step[+sessionStorage.getItem("doIndex")],
                classId: sessionStorage.getItem("classId"),
                controlId: element.cont.id,
                id: element.id ? element.id : "",
                controlTypes: element.cont.type,
                experimentId: this.$store.state.doCase.experimentId,
                pyId: this.$store.state.doCase.caseId,
                questionAnswer: JSON.stringify(element.item.list),
                tsId: this.$parent.cont ? this.$parent.cont.id : idid,
                userId: this.$role.code
              };
              break;
            default:
              break;
          }
          if (!element.cont.isShow) {
            data.push(data2);
            console.log("1", data);
          }
        }
      });

      if (!state) {
        return this.$Message.error("请填写完整");
      }
      if (this.isWorking === false) {
        this.isWorking = true;
        this.$http
          .createStuControl(data)
          .then(res => {
            if (res.data.success) {
              setTimeout(() => {
              this.isWorking = false;
              }, 800);
              this.$emit("Determine");
            } else {
              this.isWorking = false;
            }
          })
          .catch(() => {
            this.isWorking = false;
          });
      }
    }
  },
  components: {
    SINGLECHOICE,
    MULTIPLECHOICEA,
    MULTIPLECHOICEB,
    SINGLETEXT,
    GAPFILLING,
    ESSAYQUESTION,
    SMALLTITLE,
    FILLBLANKS,
    TEXTAXIS,
    PICTURETEXT,
    VIDEOFILE,
    DIALOGUE,
    HEADLINE
  },
  props: ["cont", "tsIndex", "Boer"],
  data() {
    return {
      value: true,
      Completed: sessionStorage.getItem("Completed") === "true",
      tsId: this.$parent.sceneControlList
        ? "this.$parent.sceneControlList[0].tsId"
        : this.$parent.doCase.caseData[this.$parent.step[this.$parent.index]]
            .tsId,
      content: [],
      comState: false, // 组件的显示状态
      HistoryData: [],
      Pattern: false, // 单个显示还是多个显示
      step: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
      AloneControl: [
        "SINGLECHOICE",
        "MULTIPLECHOICEA",
        "MULTIPLECHOICEB",
        "MULTIPLECHOICEB",
        "SINGLETEXT",
        "GAPFILLING",
        "ESSAYQUESTION",
        "FILLBLANKS",
        "TEXTAXIS",
        "PICTURETEXT"
      ],
      isWorking: false
    };
  },
  watch: {
    cont: {
      handler() {
        this.Pattern = Array.isArray(this.cont);
        if (!Array.isArray(this.cont)) {
          console.log("单个");
          console.log(this.cont);
          if (this.cont.type === "DIALOGUE") {
            this.value = false;
          }
          return;
        }
        const find = value => {
          if (this.AloneControl.indexOf(value.type) !== -1) {
            /** 如果有题目就显示为一页 */
            return true;
          }
        };
        if (!this.cont) {
          console.log(11111);
          this.$emit("Determine");
          return;
        }
        if (this.cont.find(find)) {
          this.Pattern = true;
        }
        this.$nextTick(() => {
          this.query();
        });
      },
      immediate: true,
      deep: true
    }
  },
  created() {}
};
</script>

<style lang="stylus" scoped>
.arrControl
  width 860px
  background rgba(255, 255, 255, 1)
  position fixed
  // top 100px
  // bottom 75px
  left 0
  right 0
  margin auto
  z-index 100
  text-align left
  margin-bottom 80px
  >>>.ivu-radio-wrapper
    white-space inherit !important
  .com
    margin-bottom 20px
  .Multiple
    padding 36px 32px
  .bottom-button
    width 100px
    height 40px
    background rgba(58, 118, 210, 1)
    border-radius 4px
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(255, 255, 255, 1)
    line-height 18px
    border none
    outline none
    float right
</style>
